export { default as PersonPage } from './person-page.jsx';
export { default as EventPage } from './event-page.jsx';
export { default as CompanyPage } from './company-page.jsx';
export { default as NewsPage } from './news-page.jsx';
